import * as React from 'react';
// material
import { Modal, Box } from '@mui/material';
import Iconify from '../iconify';
// -------------------------------------------------------------------------------------------------

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'grey.200',
    width: 320,
    height: 230,
    display: 'flex',
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 1.5,
};
// -------------------------------------------------------------------------------------------------

export default function LoadingProgressBar() {

    return (
        <div>
            <Modal open >
                <Box sx={style}>
                    <Iconify icon="svg-spinners:bars-rotate-fade" width={70} height={70} />
                </Box>
            </Modal>
        </div >
    );
}